module.exports = __webpack_public_path__ + "static/media/sm_slices_1.da035530.jpg";